module.exports = __webpack_public_path__ + "static/img/sqds.105e09f9.png";